<div class="banner">
  <div class="jumbotron" style="text-align: center">
    <h1>SDG Badges</h1>
  </div>
</div>

<div class="container-fluid content-container">
  <div class="content">
    <h1 class="results-heading">How to display your own SDG badge</h1>
    <div class="grid">
      <div class="sm:col-12 md:col-10 lg:col-8 xl:col-6 md:col-offset-1 lg:col-offset-2 xl:col-offset-3">
        <div class="grid flex">
          <div class="sm:col-12 md:col-12 lg:col-4 xl:col-4">
            <img src="assets/img/screenshot_sdg_badge.png" alt="Screenshot SDG badge">
          </div>
          <div class="sm:col-12 md:col-12 lg:col-8 xl:col-8">
            <p>With the SDG badges service you can generate an SDG Badge yourself for your content, and embed it on
              your webpages.</p>
            <p>It's simple: to generate a badge for a given text, enter a text fragment in any of the 104 common world languages in our <a [routerLink]="['/sdg-classifier/text']">classification service</a>
              to what extent this text fragment relates to each SDG goal from 0% to 100%. (If you are a web developer or
              data engineer read more below)</p>
            <p>You can select four different AI models to classify the text fragments with. Each of one has a slightly
              different outcome. Our default model is the Aurora SDG model, which has been tested rigorously.</p>
            <a [routerLink]="['/about/models']">[Learn more]</a>
          </div>
          <div class="col-12">
            <p>At the bottom you find an html snippet generator, allowing you to insert a specfic badge on your web-page.</p>
            <div class="grid">
              <div class="col-12">
                <p>You can choose the size of badge by entering the height in pixels into the input field.</p>
              </div>
              <div class="col-8 col-offset-2">
                <img width="300" style="box-shadow: 5px 5px 2px lightgrey; border: 2px black;" src="assets/img/screenshot_select_badge_size.png" alt="Screenshot selecting badge size">
              </div>
              <div class="col-12">
                <p>Than you can use icons on the right to copy the html fragment into the clipboard and the into your page whereever you want the SDG badge to be displayed. </p>
              </div>
              <div class="col-8 col-offset-2">
                <img width="800" style="box-shadow: 5px 5px 2px lightgrey; border: 2px black; max-width: 100%;" src="assets/img/screenshot_copy_code_fragments.png" alt="Screenshot copying code fragments">
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="content">
    <h1 class="results-heading">Advanced embedding of badges</h1>
    <div class="grid">
      <div class="sm:col-12 md:col-10 lg:col-8 xl:col-6 md:col-offset-1 lg:col-offset-2 xl:col-offset-3">
        <p>If you plan to embed the SDG in your auto-generated publication list or your repository, you can include the following html part in the webpage by inserting the following div element:</p>
        <blockquote class="blockquote" style="background-color: lightgrey;">
          <pre><code>&lt;div class=&quot;sdg-wheel&quot; data-wheel-height=[height] data-model=[model] data-text=[text]&gt;&lt;/div&gt;</code></pre>
        </blockquote>
        <p>the placeholders need to be replaced by the appropriate values:</p>
        <ul>
          <li>
            <code>[height]</code>: the height of the badge in pixels.
          </li>
          <li>
            <code>[model]</code>: the model to be used for classification. available options are 'aurora-sdg', 'aurora-sdg-multi', 'osdg' and 'elsevier-sdg-multi'. Please refer to our <a [routerLink]="['/about/models']">About the models</a> page for further information.
          </li>
          <li>
            <code>[text]</code>: the text you want to be classified and displayed as SDG batch (e.g. the abstract of the repository entry).
          </li>
        </ul>
        <p>And don't forget to load our widget javascript file to generate the badges form the predefined div elements:</p>
        <blockquote class="blockquote" style="background-color: lightgrey;">
          <pre><code>&lt;script src=&quot;https://{{serviceBaseAddress}}/resources/widget.js&quot; type=&quot;text/javascript&quot;&gt;&lt;/script&gt;</code></pre>
        </blockquote>
      </div>
    </div>
  </div>
</div>
